module.exports = __webpack_public_path__ + "img/internet.4982d853.webp";